import React from 'react'
import TopNavbar from '../Nav/TopNavbar'

import Footer from '../Sections/Footer'
import Healthtips from '../Sections/Healthtips'

function Quicktips() {
    return (
      <>
          <TopNavbar/>
          <Healthtips/>
          <Footer/>
      </>
    )
}

export default Quicktips